import { api } from "@/shared/libs/axiosClient";
import type {
  CreateErrorPatternRequest,
  DeleteErrorPatternsRequest,
  DeleteErrorPatternsResponse,
  ErrorPatternResponse,
  ErrorPatternsResponse,
  UpdateErrorPatternRequest,
} from "@/types/collection-types";

/**
 * 오류 패턴 목록 조회
 */
export async function fetchErrorPatterns(): Promise<ErrorPatternsResponse> {
  return api.get<ErrorPatternsResponse>("/error-patterns");
}

/**
 * 오류 패턴 생성
 */
export async function createErrorPattern(
  request: CreateErrorPatternRequest
): Promise<ErrorPatternResponse> {
  return api.post<ErrorPatternResponse>("/error-patterns", request);
}

/**
 * 오류 패턴 수정
 */
export async function updateErrorPattern(
  patternId: number,
  request: UpdateErrorPatternRequest
): Promise<ErrorPatternResponse> {
  return api.put<ErrorPatternResponse>(`/error-patterns/${patternId}`, request);
}

/**
 * 오류 패턴 삭제
 */
export async function deleteErrorPatterns(
  request: DeleteErrorPatternsRequest
): Promise<DeleteErrorPatternsResponse> {
  return api.post<DeleteErrorPatternsResponse>("/error-patterns/delete", request);
}
